export default {
  initProject: 'INIT_PROJECT_COMMON', // 初始化获取完成token
  refreshCoursewareList: 'REFRESH_COURSEWARE_LIST', // 刷新课件列表
  refreshTemplateList: 'REFRESH_TEMPLATE_LIST', // 刷新模版列表
  refreshCategory: 'REFRESH_CATEGORY', // 刷新分类列表
  refreshBackgroundList: 'REFRESH_BACKGROUND_LIST', // 刷新背景图列表
  newPageCreated: 'NEW_PAGE_CREATED', // socket推送，有新页面生成
  coursewareTestOver: 'COURSEWARE_TEST_OVER', // socket推送，当有课件质检完成
  coursewareTestError: 'COURSEWARE_TEST_ERROR' // socket推送，当有课件质检失败
}



// WEBPACK FOOTER //
// ./src/config/eventBusMap.js